import {takeLatest, call, put} from 'redux-saga/effects';
import {
  getSpecialistAdminConsultationListRequest,
  getSpecialistAdminConsultationListSuccess,
  getSpecialistAdminConsultationListFailure,
  getSpecialistOnboardingListRequest,
  getSpecialistOnboardingListSuccess,
  getSpecialistOnboardingListFailure,
  getSpecialistAdminProfileRequest,
  getSpecialistAdminProfileSuccess,
  getSpecialistAdminProfileFailure,
  specialistAdminProfileRequestChangeRequest,
  specialistAdminProfileRequestChangeSuccess,
  specialistAdminProfileRequestChangeFailure,
  setSpecialistAdminProfileFeeAndVisibilityRequest,
  setSpecialistAdminProfileFeeAndVisibilitySuccess,
  setSpecialistAdminProfileFeeAndVisibilityFailure,

  // get hospital list api
  getHospitalListRequest,
  getHospitalListSuccess,
  getHospitalListFailure,
} from '../slices/specialistAdminSlice';
import {
  getSpecialistAdminConsultationList,
  getSpecialistOnboardingList,
  getSpecialistAdminProfile,
  specialistAdminProfileRequestChange,
  setSpecialistAdminProfileFeeAndVisibility,
  getHospitalList,
} from '@/services/api';
import {SUCCESS_KEY} from '@/constants/keys';

function* GetSpecialistAdminConsultationListSaga(action: any): Generator {
  try {
    const response: any = yield call(getSpecialistAdminConsultationList, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistAdminConsultationListSuccess(response.data));
    } else {
      yield put(getSpecialistAdminConsultationListFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistAdminConsultationListFailure(error.response));
  }
}

function* GetSpecialistOnboardingListSaga(action: any): Generator {
  try {
    const response: any = yield call(getSpecialistOnboardingList, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistOnboardingListSuccess(response.data));
    } else {
      yield put(getSpecialistOnboardingListFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistOnboardingListFailure(error.response));
  }
}

function* GetSpecialistAdminProfileSaga(action: any): Generator {
  try {
    const response: any = yield call(getSpecialistAdminProfile, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistAdminProfileSuccess(response.data));
    } else {
      yield put(getSpecialistAdminProfileFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistAdminProfileFailure(error.response));
  }
}

function* SpecialistAdminProfileRequestChangeSaga(action: any): Generator {
  try {
    const response: any = yield call(specialistAdminProfileRequestChange, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(specialistAdminProfileRequestChangeSuccess(response.data));
    } else {
      yield put(specialistAdminProfileRequestChangeFailure(response.data));
    }
  } catch (error: any) {
    yield put(specialistAdminProfileRequestChangeFailure(error.response));
  }
}

function* SetSpecialistAdminProfileFeeAndVisibilitySaga(action: any): Generator {
  try {
    const response: any = yield call(setSpecialistAdminProfileFeeAndVisibility, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(setSpecialistAdminProfileFeeAndVisibilitySuccess(response.data));
    } else {
      yield put(setSpecialistAdminProfileFeeAndVisibilityFailure(response.data));
    }
  } catch (error: any) {
    yield put(setSpecialistAdminProfileFeeAndVisibilityFailure(error.response));
  }
}

function* GetHospitalListSaga(): Generator {
  try {
    const response: any = yield call(getHospitalList);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getHospitalListSuccess(response.data));
    } else {
      yield put(getHospitalListFailure(response.data));
    }
  } catch (error: any) {
    yield put(getHospitalListFailure(error.response));
  }
}

export default function* specialistAdminSaga(): Generator {
  yield takeLatest(getSpecialistAdminConsultationListRequest.type, GetSpecialistAdminConsultationListSaga);
  yield takeLatest(getSpecialistOnboardingListRequest.type, GetSpecialistOnboardingListSaga);
  yield takeLatest(getSpecialistAdminProfileRequest.type, GetSpecialistAdminProfileSaga);
  yield takeLatest(specialistAdminProfileRequestChangeRequest.type, SpecialistAdminProfileRequestChangeSaga);
  yield takeLatest(setSpecialistAdminProfileFeeAndVisibilityRequest.type, SetSpecialistAdminProfileFeeAndVisibilitySaga);
  yield takeLatest(getHospitalListRequest.type, GetHospitalListSaga);
}
